// Utility function to remove undefined values from objects before sending to Firestore
export const cleanFirestoreData = (obj: any): any => {
  if (obj === null || obj === undefined) {
    return obj;
  }
  
  if (Array.isArray(obj)) {
    return obj.map(cleanFirestoreData);
  }
  
  if (typeof obj === 'object') {
    const cleaned: any = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        if (value !== undefined) {
          cleaned[key] = cleanFirestoreData(value);
        }
      }
    }
    return cleaned;
  }
  
  return obj;
};
